import { API } from "aws-amplify";


const showManagement = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    const ret = await API.get("InasakuAPI", "/api/management", myInit);
    return ret.data;
};


export default {
    showManagement,
};
